<template>
    <div class="study-list">
        <ul>
            <li v-for="(item,index) in list" :key="index">
                <a :href="`#/studyDetail/${name}/${item.articleid}/${item.sortid}`">
                    <p>
                        <img v-lazy="item.img" alt="" />
                    </p>
                    <p>{{item.title}}</p>
                    <p>首播：{{item.date_ymdhis}}</p>
                </a>
            </li>
        </ul>
        <div class="setting">
            <a :href="`#/course/${name}`">
                <img src="../../assets/images/more.jpg" alt="" />    
            </a> 
            <!-- <a href="javascript:;" class="change">
                <img src="../../assets/images/change.jpg" alt="" />
            </a>    -->
        </div>    
    </div>
</template>

<script>

export default{
    name: 'List',
    props:{
        name: String,
        list: Array
    }
}
</script>

<style lang="less" scoped>
    .study-list{
        overflow: hidden;
        padding-bottom: 0.4rem;
        margin-bottom: 0.3rem;
        border-bottom: 1px solid #f1f1f1;
        ul{
            display: flex;
            flex-wrap: wrap;
        }
        li{
            width: 48%;
            box-sizing: border-box;
            margin: 0 0.37rem 0.37rem 0;
            &:nth-of-type(2n){
                margin-right: 0;    
            }
            a{
                display: block;
                font-size: 0.36rem;
                color: #333;
            }
            p{
                &:nth-of-type(1){
                    margin-bottom: 0.15rem;
                }
                &:nth-last-of-type(1){
                    margin-top: 0.13rem;
                    font-size: 0.27rem;
                    color: #888;
                }
            }
            img{
                width: 100%;
                border-radius: 0.2rem;
            }    
        }
        .setting{
            overflow: hidden;
            margin-top: 0.25rem;
            text-align: center;
            img{
                width: 100%;
            }
            a{
                width: 48%;
                display: inline-block;
                margin-right: 0.3rem; 
            }
            .change{
                margin-right: 0;
            }
        }
    }          
</style>   